import { HttpClient as HttpClientIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { light, ThemeProvider } from '@amboss/design-system';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { Credits } from './components/cards/credits/Credits';
import ErrorBoundary from './components/cards/ErrorBoundary';
import SocketProvider from './contexts/SocketProvider';
import ModalProvider from './hooks/useModal';
import reportWebVitals from './reportWebVitals';
import Home from './routes/Home';
import { persistor, store } from './store/store';

if (window.sentry_dsn) {
  Sentry.init({
    dsn: window.sentry_dsn,
    environment: window.environment,
    release: window.release,
    integrations: [
      new HttpClientIntegration({
        failedRequestStatusCodes: [[400, 599], 599],
      }),
    ],
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>

  // </React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ModalProvider>
          <ThemeProvider theme={light}>
            <SocketProvider>
              <Routes>
                <Route path='/' element={<App />}>
                  <Route index element={<Home />} />
                  <Route path='credits' element={<Credits />} />
                  <Route path='*' element={<ErrorBoundary />} />
                </Route>
              </Routes>
            </SocketProvider>
          </ThemeProvider>
        </ModalProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
